/*!

=========================================================
* Argon Dashboard PRO React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

*/
import React from 'react';
// react library for routing
import {
  useLocation, Route, Switch, Redirect
} from 'react-router-dom';

// core components
import routes from '../routes';
import AuthFooter from '../components/Footers/AuthFooter';

function AuthLayout() {
  const location = useLocation();
  const mainContentRef = React.useRef(null);

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContentRef.current.scrollTop = 0;
    document.body.classList.add('bg-default');
    // Specify how to clean up after this effect:
    return function cleanup() {
      document.body.classList.remove('bg-default');
    };
  });

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContentRef.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routeConfig) => routeConfig.map((prop, key) => {
    if (prop.collapse) {
      return getRoutes(prop.views);
    }

    if (prop.layout === '/auth') {
      return (
        <Route
          path={prop.layout + prop.path}
          component={prop.component}
          key={key}
          exact={prop.exact || false}
        />
      );
    }

    return null;
  });

  const routesToRender = getRoutes(routes);

  // TODO: move all routes to App component. It does not save much to render them here.
  return (
    <>
      <div className="main-content" ref={mainContentRef}>
        <Switch>
          {routesToRender}
          <Redirect from="*" to="/auth/login" />
        </Switch>
      </div>
      <AuthFooter />
    </>
  );
}

export default AuthLayout;
